import {ServerError} from '@/interfaces/interfaces';
import {AxiosError} from 'axios';
import store from '@/store';

export default (error: AxiosError) => {
  store.commit('TOGGLE_LOADING', {isLoading: false});
  if (error.response) {
    const msg: ServerError = error.response.data;
    alert('Error message: ' + msg.message + '\nError code: ' + msg.code);
  } else {
    alert(error.message);
  }
};
